import * as React from 'react';
import { FunctionComponent, useEffect } from 'react';
import styled from 'styled-components';
import { uuid } from '../helpers';
import { useZakeke } from '../hooks/useZakeke';
import { useInternalState } from '../state/provider';
import { DebugPanel } from './debugs/debugPanel';

const ZakekeViewerContainer = styled.div<{ backgroundColor?: string | null }>`
	width: 100%;
	height: 100%;
	position: relative;
	outline: none !important;

	canvas {
		outline: none !important;
		background-color: ${(props) => (props.backgroundColor ? props.backgroundColor : 'transparent')};
	}
`;

// Persistent mode will keep the SceneEditor alive after unmount.
// You should save the current editor with the ref
export const ZakekeViewer: FunctionComponent<{ bgColor?: string; className?: string }> = ({ className, bgColor }) => {
	const [guid] = React.useState(uuid());

	const { isViewerReady, internalAppendViewer, backgroundColor, removeBackground } = useZakeke();
	const internalState = useInternalState();
	const stateRef = React.useRef(internalState);

	const getBackgroundColor = () => {
		const isFullscreen = !!document.fullscreenElement;
		const removeBackground = stateRef.current.state.environment.removeBackground;
		const backgroundColor = stateRef.current.state.environment.backgroundColor;
		if (!isFullscreen && removeBackground) return null; //			1 non cè' il background
		if (!isFullscreen && backgroundColor) return backgroundColor; // 2 background lato config
		return bgColor ?? '#f2f2f2'; //					3 background lato tema o default
	};
	const [stateBackgroundCol, setStateBackgroundCol] = React.useState<string | null>(getBackgroundColor());

	useEffect(() => {
		if (isViewerReady) internalAppendViewer(document.getElementById('zakeke-viewer-container-' + guid)!);
	}, [isViewerReady]);

	useEffect(() => {
		setStateBackgroundCol(getBackgroundColor());
		const e = () => {
			setStateBackgroundCol(getBackgroundColor());
		};
		document.addEventListener('fullscreenchange', e);
		return () => {
			document.removeEventListener('fullscreenchange', e);
		};
	}, []);

	return (
		<ZakekeViewerContainer backgroundColor={stateBackgroundCol} id={'zakeke-viewer-container-' + guid} className={`zakeke-viewer-container ${className}`}>
			{stateRef?.current.state.isDebug && <DebugPanel />}
		</ZakekeViewerContainer>
	);
};
